// extracted by mini-css-extract-plugin
export default {"instagram":"zk9DDs","imageRatio":"JQ99dA","content":"hYvruA","userName":"yxco_b"};